import React from "react";
import { ScreenHeading } from "../../componets/ScreenHeading/ScreenHeading";
import { ScrollService } from "../../componets/ScrollService";
import { Animations } from "../../componets/Animations";
import { projects } from "../../constants/constants";
import "./Projects.css";

export function Projects(props) {
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;
    Animations.animations.fadeInScreen(props.id);
  };
  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  return (
    <div
      className={"project-container screen-container  fade-in"}
      id={props.id || ""}
    >
      <div className={"project-parent"}>
        <ScreenHeading title={"Projects"} subHeading={"My work so far"} />
        <div className={"project-container"}>
          <div className={"projects-grid"}>
            {projects.map(
              ({ id, image, title, description, tags, source, visit }) => (
                <div className={"project-card"} key={id}>
                  <img className={"img-card"} src={image} alt={"imagId"} />
                  <div className={"title-content"}>
                    <h3>{title}</h3>
                    <div className={"project-separator-line"} />
                  </div>
                  <div className={"card-description"}>{description}</div>
                  <div className={"project-options"}>
                    {visit ? (
                      <a href={visit} target="_blank" rel="noreferrer">
                        <button className={"btn primary-btn"}>Visit</button>
                      </a>
                    ) : (
                      <div />
                    )}
                    {source ? (
                      <a href={source} target="_blank" rel="noreferrer">
                        <button className={"btn highlighted-btn"}>
                          Source
                        </button>
                      </a>
                    ) : (
                      <div />
                    )}
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
